import Colors from './_colors'
import Fonts from './_fonts'

const GlobalStyle = () => (
  <>
    <Colors />
    <Fonts />
  </>
)

export default GlobalStyle
